import {combineReducers} from '@reduxjs/toolkit';

// import userSliceReducer from '../features/userSlice';
import pageSliceReducer from '../features/pageSlice';

export const reducer = {
  // user: userSliceReducer,
  page: pageSliceReducer,
};

export const rootReducer = combineReducers(reducer);
